import {DashboardType} from "../../../model/dashboard/types";
import {DashboardConfig} from "../../../model/dashboard/dashboard-config";
import {WidgetType} from "../../../model/widget/widget-type";

export function myTeamDashboardConfig(userIds:ID[]) {

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.CUSTOM,
        "widgets"   : []
    }

    // let companyUserIds : ID[] = gd.session.companyUsers.exportToArrayUserId()
    // companyUserIds = companyUserIds.slice(0,5)

    const widgetIds: ID[] = []

    _.map(userIds, (userId: ID, key:number)=>{
        dashboardConfig.widgets = dashboardConfig.widgets.concat(createWidgets(userId, widgetIds) as any[])
    })

    return dashboardConfig
}


function createWidgets(userId:ID, widgetIds:ID[]) {

    const user = gd.session.users.get(userId)

    // double it's value
    // row = row * 2

    if (!user) {
        console.log("no user ", userId, "found")
        return []
    }

    // {
    //     "id": generateUniqueId(),
    //     "type": "quick-notes",
    //     "title": `${user.name} Goals`,
    //     "color": 6,
    //     "cardLayout": "none",
    //     "gridPosition": {
    //     "x": 0,
    //         "y": 0,
    //         "w": 3,
    //         "h": 2
    // },
    //     "settings": {
    //     "displayGrid": false
    // },
    //     "conditions": null,
    //     "text": "notes here"
    // },

    return [
        {
            "id": gd.utils.generateUIDWithCollisionChecking(widgetIds),
            "type": WidgetType.PROFILE_USER,
            "title": ``,    // ${user.name} Goals
            "color": 6,
            "cardLayout": "none",
            "gridPosition": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "settings": {
                "userId": user.id
            },
            "conditions": null
        },
        {
            "id": gd.utils.generateUIDWithCollisionChecking(widgetIds),
            "type": "counter",
            "title": "Pastdue tasks",
            "color": 16,
            "cardLayout": "top",
            "gridPosition": {
                "x": 7,
                "y": 0,
                "w": 2,
                "h": 1
            },
            "settings": {
                "counterType": "tasks-total",
                "label": null,
                "includeSubtasks": true,
                "showClosedTasks": false
            },
            "conditions": {
                "logicalOperator": "AND",
                "conditions": [
                    {
                        "id": "cond1",
                        "systemFieldId": "task.deadline",
                        "type": "date-relative-before",
                        "value": 0
                    },
                    {
                        "id": "zezj",
                        "systemFieldId": "task.assignedToUserId",
                        "type": "includes",
                        "value": [user.id]
                    }
                ]
            }
        },
        {
            "id": gd.utils.generateUIDWithCollisionChecking(widgetIds),
            "type": "counter",
            "title": "Time reported this week",
            "color": 6,
            "cardLayout": "none",
            "gridPosition": {
                "x": 7,
                "y": 1,
                "w": 2,
                "h": 1
            },
            "settings": {
                "counterType": "time-reports",
                "label": "Hours"
            },
            "conditions": {
                "logicalOperator": "AND",
                "conditions": [
                    {
                        "id": "cond1",
                        "systemFieldId": "timeReport.date",
                        "type": "date-relative-after",
                        "value": -7
                    },
                    {
                        "id": "mt3d",
                        "systemFieldId": "timeReport.userId",
                        "type": "includes",
                        "value": [user.id]
                    }
                ]
            }
        },
        {
            "id": gd.utils.generateUIDWithCollisionChecking(widgetIds),
            "type": "task-list",
            "title": "Assigned tasks",
            "color": 6,
            "cardLayout": "none",
            "gridPosition": {
                "x": 3,
                "y": 0,
                "w": 4,
                "h": 2
            },
            "settings": {
                "includeSubFolders": true,
                "displayPropertyFieldId": "projectId",
                "includeSubtasks": true,
                "showClosedTasks": false
            },
            "conditions": {
                "logicalOperator": "OR",
                "conditions": [
                    {
                        "id": "747l",
                        "systemFieldId": "task.actionRequiredUserId",
                        "type": "includes",
                        "value": [user.id]
                    },
                    {
                        "id": "evjm",
                        "systemFieldId": "task.assignedToUserId",
                        "type": "includes",
                        "value": [user.id]
                    }
                ]
            }
        },
        {
            "id": gd.utils.generateUIDWithCollisionChecking(widgetIds),
            "type": "task-chart",
            "title": "Tasks by status",
            "color": 6,
            "cardLayout": "none",
            "gridPosition": {
                "x": 9,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "settings": {
                "includeSubFolders": true,
                "graphType": "bar",
                "counterType": "tasks-total",
                "groupBy": "statusId",
                "includeSubtasks": true,
                "showClosedTasks": false
            },
            "conditions": {
                "logicalOperator": "AND",
                "conditions": [
                    {
                        "id": "2dnp",
                        "systemFieldId": "task.assignedToUserId",
                        "type": "includes",
                        "value": [user.id]
                    }
                ]
            }
        }
    ]
}